import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "override-dialog__message" };
const _hoisted_2 = { class: "text-body-2 mb-3" };
const _hoisted_3 = { class: "text-body-3 text-medium-emphasis" };
const _hoisted_4 = { class: "override-dialog__verdict-options" };
const _hoisted_5 = ["onClick"];
import { computed, ref, watch } from "vue";
import { orderInfoService } from "@/services/orderInfoService";
import { REQUESTABLE_VERDICT_OPTIONS, verdictDisplay } from "@/constants/drugIndication";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DrugIndicationOverrideDialog',
    props: {
        modelValue: { type: Boolean },
        orderKey: {},
        check: {}
    },
    emits: {
        "update:modelValue": (_value) => true,
        submitted: () => true,
    },
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const requestedVerdict = ref("");
        const requestedDoNotUse = ref(false);
        const reason = ref("");
        const loading = ref(false);
        const errorMsg = ref("");
        // Every requestable verdict is offered, the current one included and marked: a correction may be
        // to the contraindication flag alone, leaving the verdict as it is. `hasChange` is what gates
        // submission, mirroring the backend rule.
        const verdictOptions = computed(() => REQUESTABLE_VERDICT_OPTIONS.map((option) => ({
            ...option,
            label: option.value === props.check?.verdict ? `${option.label} (current)` : option.label,
        })));
        // Same rule as the backend's _validate_override_request: a request must move the verdict, the
        // contraindication flag, or both — an identical request is not a correction.
        const hasChange = computed(() => requestedVerdict.value !== props.check?.verdict || requestedDoNotUse.value !== Boolean(props.check?.doNotUse));
        const verdictColor = (verdict) => verdictDisplay(verdict).color;
        const verdictLabel = (verdict) => verdictDisplay(verdict).label;
        watch(() => props.modelValue, (open) => {
            if (open) {
                // Preselect the current verdict when it is requestable, so a flag-only correction is one
                // click. `unverified` is disputable but not requestable, so it leaves the choice empty.
                const current = props.check?.verdict ?? "";
                requestedVerdict.value = REQUESTABLE_VERDICT_OPTIONS.some((option) => option.value === current) ? current : "";
                requestedDoNotUse.value = props.check?.doNotUse || false;
                reason.value = "";
                errorMsg.value = "";
            }
        });
        function onDialogToggle(_value) {
            if (!loading.value)
                emit("update:modelValue", _value);
        }
        function onCancel() {
            emit("update:modelValue", false);
        }
        async function onSubmit() {
            if (!requestedVerdict.value || !reason.value.trim() || !hasChange.value)
                return;
            loading.value = true;
            errorMsg.value = "";
            try {
                const payload = {
                    medication: props.check.medication,
                    requestedVerdict: requestedVerdict.value,
                    requestedDoNotUse: requestedDoNotUse.value,
                    reason: reason.value.trim(),
                };
                await orderInfoService.requestDrugIndicationOverride(props.orderKey, payload);
                // The parent flips the row to its "Override pending review" chip — that is the confirmation.
                emit("submitted");
                emit("update:modelValue", false);
            }
            catch (e) {
                const error = e;
                errorMsg.value = error?.message || "Failed to submit the request. Please try again.";
            }
            finally {
                loading.value = false;
            }
        }
        return (_ctx, _cache) => {
            const _component_v_card_title = _resolveComponent("v-card-title");
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_checkbox = _resolveComponent("v-checkbox");
            const _component_v_textarea = _resolveComponent("v-textarea");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_card_text = _resolveComponent("v-card-text");
            const _component_v_spacer = _resolveComponent("v-spacer");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_card = _resolveComponent("v-card");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": __props.modelValue,
                "max-width": "520",
                scrim: true,
                class: "override-dialog-overlay",
                "onUpdate:modelValue": onDialogToggle
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, { class: "override-dialog" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "override-dialog__title" }, {
                                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                        _createTextVNode("Request Verdict Change", -1)
                                    ]))]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "override-dialog__body" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_1, [
                                        _createElementVNode("div", _hoisted_2, [
                                            _createElementVNode("strong", null, _toDisplayString(__props.check?.medication), 1),
                                            _cache[3] || (_cache[3] = _createTextVNode(" for diagnosis ", -1)),
                                            _createElementVNode("strong", null, _toDisplayString(__props.check?.icd10Code), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_3, [
                                            _cache[4] || (_cache[4] = _createTextVNode(" Current verdict: ", -1)),
                                            _createVNode(_component_v_chip, {
                                                color: verdictColor(__props.check?.verdict),
                                                size: "small",
                                                variant: "flat",
                                                label: ""
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(verdictLabel(__props.check?.verdict)), 1)
                                                ]),
                                                _: 1
                                            }, 8, ["color"])
                                        ])
                                    ]),
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "override-dialog__section-label mt-5 mb-3" }, "What should the verdict be?", -1)),
                                    _createElementVNode("div", _hoisted_4, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(verdictOptions.value, (option) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                                key: option.value,
                                                type: "button",
                                                class: _normalizeClass(["override-dialog__chip", { 'override-dialog__chip--selected': requestedVerdict.value === option.value }]),
                                                onClick: ($event) => (requestedVerdict.value = option.value)
                                            }, _toDisplayString(option.label), 11, _hoisted_5));
                                        }), 128))
                                    ]),
                                    _createVNode(_component_v_checkbox, {
                                        modelValue: requestedDoNotUse.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((requestedDoNotUse).value = $event)),
                                        label: "Contraindication / boxed warning applies",
                                        class: "mt-4 mb-2",
                                        "hide-details": ""
                                    }, null, 8, ["modelValue"]),
                                    _createVNode(_component_v_textarea, {
                                        modelValue: reason.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((reason).value = $event)),
                                        label: "Reason for this change (required)",
                                        rows: "3",
                                        "auto-grow": "",
                                        maxlength: "1000",
                                        class: "mt-3",
                                        counter: "",
                                        "hide-details": "auto",
                                        required: ""
                                    }, null, 8, ["modelValue"]),
                                    (errorMsg.value)
                                        ? (_openBlock(), _createBlock(_component_v_alert, {
                                            key: 0,
                                            type: "error",
                                            variant: "tonal",
                                            density: "compact",
                                            class: "mt-4"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(errorMsg.value), 1)
                                            ]),
                                            _: 1
                                        }))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }),
                            _createVNode(_component_v_card_actions, { class: "override-dialog__actions" }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_spacer),
                                    _createVNode(_component_v_btn, {
                                        variant: "text",
                                        disabled: loading.value,
                                        onClick: onCancel
                                    }, {
                                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                                _createTextVNode("Cancel", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["disabled"]),
                                    _createVNode(_component_v_btn, {
                                        color: "primary",
                                        loading: loading.value,
                                        disabled: !requestedVerdict.value || !reason.value.trim() || !hasChange.value,
                                        onClick: onSubmit
                                    }, {
                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                _createTextVNode(" Request Change ", -1)
                                            ]))]),
                                        _: 1
                                    }, 8, ["loading", "disabled"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
